import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=79c81144&scoped=true"
import script from "./DataSource.vue?vue&type=script&lang=js"
export * from "./DataSource.vue?vue&type=script&lang=js"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=79c81144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c81144",
  null
  
)

export default component.exports